import React, { useEffect } from 'react';
import { Empty } from '@/components/ui/Empty';
import { useResolution886Report } from '@/context/Resolution886Report';
import type { Key, ColumnsType, RowSelectMethod } from 'antd/lib/table/interface';
import type { Info, Row } from './types';
import { CustomTable } from './styles';

const ALL_SELECTED_TYPE: RowSelectMethod = 'all';

interface TableMultiSelectionProps<T extends Row> {
	data?: T[];
	value?: string[];
	loading?: boolean;
	columns: ColumnsType<T>;
	onChange?: (value: Key[]) => void;
	onSelectPage?: (value: string[]) => void;
	onSelect?: (record: T, selected: boolean) => void;
}

export function TableMultiSelection<T extends Row>({
	columns,
	data = [],
	value = [],
	loading = false,
	onChange = () => {},
	onSelect = () => {},
	onSelectPage = () => {}
}: Readonly<TableMultiSelectionProps<T>>) {
	const { form } = useResolution886Report();
	const idsOnCurrentPage = data?.map((item) => item.id) || [];

	useEffect(() => {
		form.setFieldValue('new_file_list_id', value);
	}, [form, value]);

	function handleOnChange(newSelectedIds: Key[], _: T[], info: Info): void {
		if (info.type === ALL_SELECTED_TYPE) {
			onSelectPage(newSelectedIds as string[]);
		}

		const selectedFromOtherPages = value.filter((id: string) => !idsOnCurrentPage.includes(id));
		const allSelectedItems = [...selectedFromOtherPages, ...newSelectedIds] as string[];
		onChange(allSelectedItems);
	}

	return (
		<CustomTable<T>
			rowKey="id"
			columns={columns}
			dataSource={data}
			loading={loading}
			pagination={false}
			tableLayout="fixed"
			rowSelection={{
				onSelect,
				type: 'checkbox',
				selectedRowKeys: value,
				onChange: handleOnChange
			}}
			className="activities-table"
			locale={{ emptyText: <Empty /> }}
		/>
	);
}
